// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e40cac45","453":"364a068b","455":"c439519e","977":"e5c98114"}[chunkId] + ".chunk.js";
};